import barbaraPic from "@/public/images/artists/barbara.png";
import { Artist } from "@/types/types";

export const barbara = {
  id: "207",
  name: "Barbara",
  image: barbaraPic,
  description: `Barbara's timbre is deep and full, with a mature, nuanced quality that complements slow ballads and smooth, jazzy tracks.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fbarbara-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Mature", "Jazz", "RnB"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 48,
        high: 64,
      },
      sweetSpot: 56,
    },
  },
} as const satisfies Artist;
